<template lang="pug">
api-form(
  :method="method"
  :serialize-data="serializeData"
  v-model="form"
  :initial="form"
  :fields="[]"
  :success-callback="successCallback"
  :error-callback="errorCallback"
)
  template(#save-btn="{ attrs, action, invalid, loading }")
    div(v-bind="extendAttrs")
      div(v-bind="extendAttrs['container-attrs']")
        api-form(
          v-for="(fieldsData, idx) in fieldsList"
          :key="idx"
          :fields="fieldsData.fields"
          :method="() => ({})"
          v-model="form"
          :initial="form"
          v-bind="fieldsData.attrs || {}"
          hide-save-btn
        )

      slot(name="save-btn" v-bind="{ attrs, action, invalid, loading }")
        v-btn.rounded-12.fit-content-width.redesignControlsBackground--text(
          v-bind="attrs"
          color="redesignSuccess"
          :disabled="invalid"
          :loading="loading"
          @click="action"
        ) Сохранить
</template>

<script>
export default {
  name: 'ManyApiForms',
  props: {
    method: { type: Function, required: true },
    value: { type: Object, default: () => ({}) },
    serializeData: { type: Function, default: (data) => data },
    fieldsList: { type: Array, default: () => [] },
    successCallback: { type: Function, default: () => {} },
    errorCallback: { type: Function, default: () => {} },
  },
  data() {
    return {};
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    extendAttrs() {
      const { $attrs } = this;
      return {
        class: 'd-flex flex-column gap-16',
        'container-attrs': {
          class: 'd-flex gap-16',
        },
        ...$attrs,
      };
    },
  },
};
</script>
